// extracted by mini-css-extract-plugin
export default {"mainButtonsContainer":"payments_mainButtonsContainer__aHDln"};